import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { Button } from "../../ui";

interface SidebarAccordionProps {
  id: string;
  label: string;
  faIcon?: IconProp;
  imgSrc?: string;
  isOpen: boolean;
  onToggle: (id: string) => void;
  children: React.ReactNode;
}

export function SidebarAccordion({
  id,
  label,
  faIcon,
  imgSrc,
  isOpen,
  onToggle,
  children,
}: SidebarAccordionProps) {
  return (
    <>
      <Button
        onClick={() => onToggle(id)}
        className="w-full flex justify-between items-center px-4 py-4 hover:bg-[#1f1f1f]"
      >
        <div className="flex items-center gap-3">
          {faIcon && <FontAwesomeIcon icon={faIcon} />}
          {imgSrc && <img src={imgSrc} alt={label} className="w-6 h-6" />}
          <span>{label}</span>
        </div>

        <FontAwesomeIcon
          icon={faChevronRight}
          className={`transition-transform ${isOpen ? "rotate-90" : ""}`}
        />
      </Button>

      <div
        className={`grid transition-all duration-300 ${
          isOpen
            ? "grid-rows-[1fr] opacity-100 pb-2"
            : "grid-rows-[0fr] opacity-0 pb-0"
        }`}
      >
        <div className="overflow-hidden">{children}</div>
      </div>
    </>
  );
}
